/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Btn_DoneInputs */

const es_walkthrough_btn_done = /** @type {(inputs: Walkthrough_Btn_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

const en_walkthrough_btn_done = /** @type {(inputs: Walkthrough_Btn_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Walkthrough_Btn_DoneInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_btn_done = /** @type {((inputs?: Walkthrough_Btn_DoneInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Btn_DoneInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_btn_done(inputs)
	return en_walkthrough_btn_done(inputs)
});
export { walkthrough_btn_done as "walkthrough.btn_done" }